import React, { forwardRef, useImperativeHandle, useState } from 'react';
import ReactModal from 'react-modal';
import { ModalStyle, OverlayStyle } from './BaseModalV2.styles';

const BaseModalV2 = forwardRef(
  ({ title, children, onClose, shouldCloseOnOverlayClick = true, onAfterClose, increasedWidth }, ref) => {
    const [show, setShow] = useState(false);

    useImperativeHandle(ref, () => ({
      show() {
        setShow(true);
      },
      hide() {
        setShow(false);
      },
      toggle() {
        setShow(prev => !prev);
      },
    }));

    return (
      <ReactModal
        isOpen={show}
        closeTimeoutMS={300}
        onRequestClose={onClose}
        onAfterClose={onAfterClose}
        className="_"
        overlayClassName="_"
        contentElement={props => <ModalStyle {...props}>{children}</ModalStyle>}
        overlayElement={(props, contentElement) => <OverlayStyle {...props}>{contentElement}</OverlayStyle>}
        shouldCloseOnEsc={shouldCloseOnOverlayClick}
        ariaHideApp={false}
        shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      />
    );
  },
);

export default BaseModalV2;
